import React from 'react';
import { Button, List, Thumbnail } from '@bynder/design-system';
import { Translate } from '@bynder/localization';
import { User } from './types';

interface Props {
	selectedUsers: User[];
	onRemoveSelectedUser: (user: User) => void;
}

export function SelectedUsers({ selectedUsers, onRemoveSelectedUser }: Props) {
	return (
		<List>
			{selectedUsers.length > 0 &&
				selectedUsers.map((user) => (
					<List.Item
						subtext={user.email}
						key={user.id}
						rightElements={
							<Button
								variant="clean"
								onClick={() => onRemoveSelectedUser(user)}
								data-testid="wf-group-management-user-remove"
							>
								<Translate id="workflow.Remove" />
							</Button>
						}
						thumbnail={
							<Thumbnail icon={user.fullName[0].toUpperCase()} shape="circle" />
						}
						data-testid="wf-group-management-selected-user"
					>
						{user.fullName}
					</List.Item>
				))}
		</List>
	);
}
